<template>
    <modal
        name="attendance-grid-columns"
        class="modal--translation modal--hide-on-loading"
        v-cloak height="auto"
        :width="(hasViewSettings ? '1000':'500')+'px'"
        :scrollable="false"
        :adaptive="true"
        :pivot-y="0.25"
        @before-open="beforeOpen"
    >

        <div class="modal-header">
            <button @click="closeModal()" type="button" class="close close-modal mr-2"><i class="fal fa-fw fa-times"></i></button>

            <h5 class="modal-title mb-0"><i class="fa fa-fw fa-cog mr-1"></i> {{trans.modal_title}}</h5>
        </div>

        <div class="modal-body p-0" :class="{'loading': loading }">

            <div class="row">

                <div class="col-md-6" v-if="hasViewSettings">

                    <h6 class="head-title">
                        <span>{{trans.title_settings_app}}</span>
                    </h6>

                    <form ref="attendanceGridColumnsFormView" class="form-settings">

                        <div class="form-group" v-for="(item,key) in viewSettings" :key="key">
                            <input class="form-check-input" type="checkbox" v-model="formViewSettings[key]" :id="'inp_view_'+ key">
                            <label class="form-check-label" :for="'inp_view_'+ key"> {{ trans[key] }}</label>
                        </div>

                        <div class="form-group" v-for="(item,index) in dynamicFields" :key="index">
                            <input class="form-check-input" type="checkbox" v-model="formPrintDynSettings['dynViewField_'+item.id]" :id="'inp_view_dynamic_field_'+item.id">
                            <label class="form-check-label" :for="'inp_view_dynamic_field_'+item.id"> {{ item.name }}</label>
                        </div>

                        <div class="form-group" v-for="(item,index) in dynamicAdditions" :key="index">
                            <input class="form-check-input" type="checkbox" v-model="formPrintDynSettings['dynViewAddition_'+index]" :id="'inp_view_dynamic_addition_'+ index">
                            <label class="form-check-label" :for="'inp_view_dynamic_addition_'+ index"> {{ trans[item.setting] }}</label>
                        </div>

                    </form>
                </div>


                <div class="col-12" :class="{'col-md-6': hasViewSettings}" :style="hasViewSettings ? 'padding-left: 2rem' : ''">
                    <h6 class="head-title">
                        <span style="white-space: nowrap">{{trans.title_settings_print}}</span>
                    </h6>

                    <form ref="attendanceGridColumnsFormPrint" class="form-settings">

                        <div class="form-group" v-for="(item,key) in printSettings" :key="key">
                            <input class="form-check-input" type="checkbox" v-model="formPrintSettings[key]" :id="'inp_print_'+key">
                            <label class="form-check-label" :for="'inp_print_'+key"> {{ trans[key] }}</label>
                        </div>

                        <div class="form-group" v-for="(item,index) in dynamicFields" :key="index">
                            <input class="form-check-input" type="checkbox" v-model="formPrintDynSettings['dynfield_'+item.id]" :id="'inp_dynamic_field_'+item.id">
                            <label class="form-check-label" :for="'inp_dynamic_field_'+item.id"> {{ item.name }}</label>
                        </div>

                        <div class="form-group" v-for="(item,index) in dynamicAdditions" :key="index">
                            <input class="form-check-input" type="checkbox" v-model="formPrintDynSettings['dynAddition_'+index]" :id="'inp_dynamic_addition_'+ index">
                            <label class="form-check-label" :for="'inp_dynamic_addition_'+ index"> {{ trans[item.setting] }}</label>
                        </div>

                    </form>
                </div>

            </div>

        </div>

        <div class="modal-footer text-center">
            <b-button type="button" variant="primary" @click="submitForm()" :class="{'loading disabled': loading }"><i class="fa fa-save"></i> {{ trans.saveBtn }}</b-button>
        </div>
    </modal>
</template>


<script>
    export default {
        props: {
            'baseUrl': {
                type: String
            },
            'trans': {
                type: Object
            },
            'viewSettings': {
                type: Object
            },
            'printSettings': {
                type: Object
            },
            'printDynSettings': {
                type: Object
            },
            'dynamicFields': {
                type: Array
            },
            'dynamicAdditions': {
                type: Object,
                default: () => ({})
            },
            'restaurantSettings': {
                type: Object
            },
            'disableReloadOnSave': {
                type: Boolean
            }
        },

        data: function() {
            return {
                url: null,
                formViewSettings: this.viewSettings,
                formPrintSettings: this.printSettings,
                formPrintDynSettings: this.getDynSettingsAssoc(this.printDynSettings),
                loading: false
            };
        },

        methods: {
            beforeOpen () {
                this.url = this.baseUrl;
            },

            submitForm() {

                let data = {
                    view: this.formViewSettings,
                    print: this.formPrintSettings,
                    printDynamic: this.formPrintDynSettings
                };

                this.loading = true;

                axios.post(this.url, data)
                    .then(() => {
                        this.closeModal();
                        if(!this.disableReloadOnSave) {
                            window.location.reload();
                        } else {
                            this.$notify({ type: 'success', title: this.trans['saved'] });
                        }
                        this.loading = false;
                    })
                    .catch(() => {
                        this.closeModal();
                        this.$notify({ type: 'error', title: 'Error!' });
                        this.loading = false;
                    });
            },

            closeModal() {
                this.$modal.hide('attendance-grid-columns');
            },

            getDynSettingsAssoc(data)
            {
                var finalObj = {};

                for(let x in this.dynamicFields)
                {
                    finalObj['dynfield_'+this.dynamicFields[x].id] = false;
                }

                for(let x in data)
                {
                    finalObj[x] = true;
                }

                return finalObj;
            }
        },
        computed: {
            hasViewSettings() {
                return Object.keys(this.viewSettings).length !== 0;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .modal-header {
        padding: 0;
        margin: 0;
        margin-bottom: 35px;
        border-bottom: 0;
    }
    h6.head-title {
        margin-bottom: 20px;
        font-size: 1.1rem;
    }
    .modal-footer {
        padding: 0;
        margin-top: 18px;
        border: 0;
    }
    .form-group {
        margin-bottom: 3px;
    }
    .form-settings {
        display: grid;
        grid-template-columns: 1fr 1fr;
        column-gap: 4rem;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/GridColumnsForm.vue